import Api from '../router/api';

export default function checkAssessmentProgress(to, from, next) {
    const token = to.params.link;

    if (!token) {
        return next('/error');
    }

    // Add a flag to prevent multiple redirects
    if (to.meta.redirected) {
        return next();
    }

    Api.getNonEmployeeStep(token)
        .then(response => {
            if (!response || !response.data || response.data.status !== 'success' || !response.data.res) {
                return next('/survey-404');
            }

            const step = response.data.res.step;
            const stepRoutes = [
                `/assessment-welcome/${token}`,
                `/assessment-instruction/${token}`,
                `/assessment-survey/${token}`,
                `/assessment-complete/${token}`
            ];

            // Validate step range
            if (step < 0 || step > 3) {
                return next(`/survey-404/${token}`);
            }

            const currentRouteIndex = stepRoutes.findIndex(route => route === to.path);

            // Only redirect if not on the correct route
            if (currentRouteIndex === -1 || currentRouteIndex !== step) {
                // Mark the route as redirected to prevent infinite loop
                const redirectRoute = stepRoutes[step];
                return next((to) => {
                    to.meta.redirected = true;
                    return { 
                        path: redirectRoute,
                        params: to.params
                    };
                });
            }

            next();
        })
        .catch(error => {
            console.error("Navigation Guard API Error:", error);
            next('/survey-404');
        });
}


// WEBPACK FOOTER //
// ./src/middleware/checkAssessmentProgress.js